import { IN_VALID_ACTION_TYPES, TP } from 'constants/consts';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'src/i18n';
import { usePropsDrillProvider } from 'utils/hooks/usePropsDrillProvider';
import styles from './ToggleSwitch.module.scss';

const ToggleSwitch = ({
  isVisible,
  onChangeVisibility,
  inValidAction,
  hasProAccountValidation,
  isHiddenProduction,
  type,
}) => {
  const { t } = useTranslation();
  const { impersonationAccount, setInValidAction } = usePropsDrillProvider();
  const [isVisibleValue, setIsVisibleValue] = useState(isVisible);

  const onShow = useCallback(() => {
    if (isHiddenProduction) {
      setInValidAction(IN_VALID_ACTION_TYPES.HIDDEN_PRODUCTION);
      return;
    }

    setIsVisibleValue(true);
    onChangeVisibility(true);
  }, []);

  const onHide = useCallback(() => {
    setIsVisibleValue(false);
    onChangeVisibility(false);
  }, []);

  const onShowHandler = hasProAccountValidation ? impersonationAccount(onShow) : onShow;
  const onHideHandler = hasProAccountValidation ? impersonationAccount(onHide) : onHide;

  const onChangeHandler = () => {
    if (inValidAction) {
      setInValidAction(type ?? IN_VALID_ACTION_TYPES.VALIDATION_PENDING_PRODUCTION);
      return;
    }

    if (isVisibleValue) {
      onHideHandler();
    } else {
      onShowHandler();
    }
  };

  return (
    <div className={styles['switch-container']}>
      <label className={styles['react-switch']}>
        <input
          checked={isVisibleValue}
          onChange={onChangeHandler}
          className={styles['react-switch-checkbox']}
          type="checkbox"
        />
        <div className={styles['react-switch-button']} />
        <div className={styles['react-switch-labels']}>
          <span>{t(`${TP}.FN_SHOW`)}</span>
          <span>{t(`${TP}.FN_HIDE`)}</span>
        </div>
      </label>
    </div>
  );
};

ToggleSwitch.propTypes = {
  isVisible: PropTypes.bool,
  inValidAction: PropTypes.bool,
  onChangeVisibility: PropTypes.func,
  hasProAccountValidation: PropTypes.bool,
  isHiddenProduction: PropTypes.bool,
};

ToggleSwitch.defaultProps = {
  isVisible: false,
  inValidAction: false,
  onChangeVisibility: () => {},
  hasProAccountValidation: true,
  isHiddenProduction: false,
};

export default ToggleSwitch;
